module.exports = __webpack_public_path__ + "img/img-12-mobile.e20b8336.webp";